import { FC } from "react";
import { Tooltip } from "react-tooltip";
import "react-tooltip/dist/react-tooltip.css";
import "./Tooltip.scss";
import Svg from "../SVG/Svg";

type Props = {
  bodyText: string;
  tooltipText: string;
  keyValue?: string;
  className?: string;
  showIcon?: boolean;
  iconWrapperClassName?: string;
  usePillStyle?: boolean;
};

const CustomTooltip: FC<Props> = ({
  bodyText,
  tooltipText,
  keyValue,
  className,
  showIcon,
  iconWrapperClassName,
  usePillStyle,
}) => {
  const triggerClass = [usePillStyle ? "custom-tooltip-trigger" : undefined, className]
    .filter(Boolean)
    .join(" ");

  return (
    <>
      <span id={keyValue} className={triggerClass}>
        {showIcon && (
          <span className={`me-2 ${iconWrapperClassName}`}>
            <Svg icon="warning" width={22} height={22} color="#fd7e14" />
          </span>
        )}
        {bodyText}
      </span>
      <Tooltip anchorId={keyValue} place="top" content={tooltipText} variant="dark" />
    </>
  );
};

export default CustomTooltip;
